import React from 'react';
import {Box, Button, List, SwipeableDrawer, Typography, useMediaQuery} from '@mui/material';
import {Menu} from '@mui/icons-material';
import {actions, useStore} from '../../store/valtio';
import SidebarMenu from '../../SidebarMenu';
import {APP_VERSION} from '../../config/settings';
import {t} from 'ttag';

const Sidebar = () => {
  const {app} = useStore();
  const isTablet = useMediaQuery((theme) => theme.breakpoints.down('xl'));

  return (
    <SwipeableDrawer
      variant={isTablet ? 'temporary' : 'permanent'}
      sx={styles.root(isTablet, app.sideBarOpen)}
      open={app.sideBarOpen}
      onClose={() => actions.app.setSideBarOpen(false)}
      onOpen={() => actions.app.setSideBarOpen(true)}
    >
      <Box display={'flex'}>
        {app.sideBarOpen && (
          <Typography sx={styles.title} variant='h6'>
            {t`Navigation`}
          </Typography>
        )}
        <Button onClick={actions.app.toggleSideBarOpen} sx={styles.menuIcon} aria-label='menu'>
          <Menu />
        </Button>
      </Box>
      <List sx={styles.list}>
        <SidebarMenu />
      </List>
      <Typography variant={'caption'} sx={{...styles.appVersionLabel(isTablet)}}>
        <small>
          <i>{APP_VERSION}</i>
        </small>
      </Typography>
    </SwipeableDrawer>
  );
};

const styles = {
  root: (isMobile, open) => {
    let dynamicStyles = {width: '15.5rem', marginTop: '3.75rem'};
    if (isMobile && !open) dynamicStyles = {width: 0, marginTop: 0};
    if (isMobile && open) dynamicStyles = {width: '15.5rem', marginTop: 0};
    if (!isMobile && !open) dynamicStyles = {width: '3.5rem', marginTop: '3.75rem'};

    return {
      zIndex: (theme) => theme.zIndex.drawer + 1,
      ...dynamicStyles,
      [`& .MuiDrawer-paper`]: {
        color: (theme) => theme.palette.secondary.contrastText,
        backgroundColor: (theme) => theme.palette.secondary.main,
        ...dynamicStyles
      }
    };
  },
  list: {
    padding: 0
  },
  title: {
    opacity: 0.54,
    color: (theme) => theme.palette.common.white,
    padding: 0,
    margin: (theme) => theme.spacing(2),
    fontFamily: (theme) => theme.typography.h2.fontFamily,
    flexGrow: 1,
    lineHeight: '1.3'
  },
  appVersionLabel: (isTablet) => ({
    opacity: 0.34,
    position: 'absolute',
    bottom: isTablet ? '1px' : '55px',
    textAlign: 'center',
    width: '100%'
  }),
  menuIcon: {
    backgroundColor: (theme) => theme.palette.secondary.dark,
    margin: 0,
    height: '3.125rem',
    color: (theme) => theme.palette.secondary.contrastText,
    minWidth: '3.125rem',
    padding: (theme) => theme.spacing(2),
    borderRadius: '0.125rem'
  },
  icon: {
    color: (theme) => theme.palette.secondary.contrastText,
    minWidth: 'unset',
    width: '1.5rem',
    marginRight: (theme) => theme.spacing(2),
    display: 'flex',
    justifyContent: 'center'
  },
  activeButton: {
    backgroundColor: (theme) => theme.palette.secondary.light,
    borderLeftWidth: '0.250rem',
    borderStyle: 'solid',
    borderLeftColor: (theme) => theme.palette.primary.main,
    paddingLeft: (theme) => theme.spacing(1) * 1.5,
    '&:hover': {
      backgroundColor: (theme) => theme.palette.secondary.light
    }
  }
};

export default Sidebar;
